mutation CreateContentPoll(
  $contentId: ID!
  $pollId: ID!
  $input: ContentPollScheduleInput!
) {
  createContentPoll(contentId: $contentId, pollId: $pollId, input: $input) {
    id
  }
}
